<script setup lang="ts">
export interface SancareBadgeProps {
  text: string
  variant?: 'neutral' | 'info'
}

withDefaults(defineProps<SancareBadgeProps>(), {
  variant: 'neutral',
})
</script>

<template>
  <span
    class="sancare-badge"
    :class="`sancare-badge--${variant}`"
  >{{ text }}</span>
</template>

<style scoped lang="scss">
@import '@sancare/typescript-commons/src/assets/styles/variables';

.sancare-badge {
  display: inline-block;
  padding: 1px 6px;
  border-radius: 4px;
  font-size: 11px;
  font-weight: 700;
  line-height: 1.4;
  white-space: nowrap;
  vertical-align: middle;

  &--neutral {
    background-color: #f0f0f0;
    color: $sancare-dark-grey;
  }

  &--info {
    background-color: #dde7f6;
    color: $sancare-dark-blue;
  }
}
</style>
